import { type FC, type ReactNode, useReducer, useEffect } from 'react';

import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

import { Toasts } from './Toasts';
import { ToastDispatchContext, ToastStateContext } from './context';
import { reducer, initialState } from './reducer';

type ToastProviderProps = {
    children: ReactNode;
    /**
     * Should not be used as pattern, added temporarily
     * and will be cleaned up with AB test
     */
    trackItemFavoriting?: boolean;
};

const ToastProvider: FC<ToastProviderProps> = ({ children, trackItemFavoriting }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (trackItemFavoriting) {
            trackAbTestV2Variant('Favorites_DriveItemFavoritesAdoption_Nov2025');
        }
    }, [trackItemFavoriting]);

    return (
        <ToastDispatchContext.Provider value={dispatch}>
            <ToastStateContext.Provider value={state}>
                {children}
                <Toasts />
            </ToastStateContext.Provider>
        </ToastDispatchContext.Provider>
    );
};

export { ToastProvider };
